export default {"src":"/_next/static/media/Grid.4139dfee.svg","height":59,"width":181,"blurWidth":0,"blurHeight":0};